import Vue from 'vue';

require('./index.css'); // require('./reset.scss')


const img1 = require('./001.png');

const img2 = require('./002.png');

import App from './App.vue';

function createApp() {
  return new Vue(App);
}

if (typeof window !== 'undefined') {
  App.el = '#root';
  createApp();
}

export default createApp;